<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检项目" prop="patrolItem">
              <a-input placeholder="请输入巡检项目" v-model="model.patrolItem"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检内容" prop="patrolContent">
              <a-textarea placeholder="请输入巡检内容" rows="4" v-model="model.patrolContent" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型" prop="devClassCode">
              <j-tree-select-custom
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="model.devClassCode"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序" prop="orderNo">
              <a-input-number placeholder="请输入排序" style="width: 100%" v-model="model.orderNo" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'YwArtificialPatrolStlForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          patrolItem: [
            { required: true, message: '请输入巡检项目!' },
          ],
          patrolContent: [
            { required: true, message: '请输入巡检内容!' },
          ],
          orderNo: [
            { required: false },
            { pattern: /^-?\d+$/, message: '请输入整数!' },
          ],
        },
        url: {
          add: "/device/patrol/ywArtificialPatrolStl/add",
          edit: "/device/patrol/ywArtificialPatrolStl/edit",
          queryById: "/device/patrol/ywArtificialPatrolStl/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>